<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          Por favor, selecione pelo menos uma empresa.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a
          {{ this.dias }} dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-component
          :opcoes="opcoes"
          :produtos="tipos_funerarios"
          :modos="modos"
          :tipos="tipos"
          :calendar="'mes'"
          @filtrar="filterData"
          @showError="showError = true"
          :title_opcao="'Campanha'"
          :campos="'N'"
        ></filtro-component>
      </v-col>
    </v-container>

    <br />

    <v-divider></v-divider>

    <br /><br />

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-gift"
            title="Comissão - Alelo"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-data-table
              :headers="ranking_header"
              :items="lista_comissao"
              :items-per-page="20"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      width: 38%;
                      font-size: 10px;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    <v-icon color="black" size="24" class="ml-2 mr-1">
                      mdi-gift
                    </v-icon>

                    {{ row.item.nome }}
                  </td>

                  <td class="linha" style="width: 25%; font-size: 14px">
                    {{ row.item.cpf }}
                  </td>

                  <td class="linha" style="width: 25%; font-size: 14px">
                    {{
                      row.item.comisao !== null
                        ? parseFloat(row.item.comisao).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : "R$ 0,0"
                    }}
                  </td>

                  <td class="linha" style="width: 6%; font-size: 14px">
                    {{ row.item.cartao }}
                  </td>
                </tr>
              </template>
            </v-data-table>

            <br />

            <div class="d-flex justify-end">
              <div style="width: 240px">
                <span
                  @click="download_alelo_xls"
                  style="
                    color: orange;
                    font-size: 48px;
                    margin-right: 12px;
                    cursor: pointer;
                  "
                  title="Download XLS"
                >
                  <i class="fas fa-gift"></i>
                </span>

                <span
                  @click="exportFeriasToPDF"
                  style="
                    color: #e74c3c;
                    font-size: 48px;
                    margin-right: 12px;
                    cursor: pointer;
                  "
                  title="Download PDF Férias"
                >
                  <i class="fas fa-file-pdf"></i>
                </span>

                <br />
              </div>
            </div>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroGeral.vue"; // Certifique-se de que o caminho esteja correto
import Comissao from "../../services/comissao";
import { ContentLoader } from "vue-content-loader";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
  },

  created() {
    (this.selectedStartDate = this.getFirstDayOfMonth()),
      (this.selectedEndDate = this.formatDateBR(new Date()));

    (this.selectedStartDate2 = this.getFirstDayOfMonth()),
      (this.selectedEndDate2 = this.formatDateBR(new Date()));
  },

  mounted() {
    this.carregarLoad();
  },

  data() {
    return {
      ranking_header: [
        { text: "Nome", value: "entregador" },
        { text: "CPF", value: "profissao" },
        { text: "Valor", value: "supervisor" },
      ],

      regras_header: [
        { text: "Regras", value: "regras" },
        { text: "Cargo", value: "cargo" },

        { text: "Percentual Migraçãao", value: "percentual_migracao" },
        { text: "Percentual", value: "percentual" },
        { text: "Produto", value: "produto" },
        { text: "Meta Plano", value: "meta_plano" },
        { text: "Meta Cremação", value: "meta_cremacao" },
        { text: "Meta Jazigo", value: "meta_jazigo" },
        { text: "Plano", value: "plano" },
        { text: "Modelo", value: "modelo" },
        { text: "Mes", value: "mes" },
        { text: "Ano", value: "ano" },

        { text: "Divisão", value: "divisao" },
        { text: "Item", value: "item" },
        { text: "Valor Item", value: "valor_item" },
        { text: "Empresa", value: "empresa" },
      ],

      lista_comissao: [],
      dias: 0,
      listagem_regras: [],
      produto: "Todos",
      bool_03: true,
      bool_02: true,
      showFilterRegras: false,
      total_resultado: 0,
      total_qtd: 0,
      total_pago_comissao: 0,
      total_pago: 0,
      subTextAddDynamic: "Total Recebido:",
      recebido_acordo: 0,
      qtd_recebido_acordo: 0,
      criado_acordo: 0,
      animationInterval: null, // Intervalo para controlar a animação
      empresa: "",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      opcoes: ["Todas", "Campanha 50 Anos"],
      selectMode: "Vencimento",
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      modos: ["Período"],
      modos2: ["SIM", "NÃO"],
      campos: "N",
      categoria: [],
      showFilter: false,
      showProgress: false,
      showError: false,
      showFilterDownload: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PARQUE DAS FLORES",
        "PREVIDA",
      ],
      tipos: ["Todos"],
      tipos_funerarios: ["Todos"],

      lista_nome_empresa: [],
    };
  },

  methods: {
    isDateValid(dateString) {
      // Verifica se a string é uma data válida
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    areDatesValid(dates) {
      // Verifica se todas as datas na matriz são válidas
      return dates.every((dateString) => {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
      });
    },

    handleFilterChange(selectedFilter, dataI, dataF, DataRI, DataRF) {
      if (selectedFilter === "Vencimento") {
        this.subTextAddDynamic = "Total Recebido: ";
      } else if (selectedFilter != "Vencimento") {
        if (
          converteDataParaFormatoISO(DataRI) <=
            converteDataParaFormatoISO(dataI) &&
          converteDataParaFormatoISO(DataRF) > converteDataParaFormatoISO(dataF)
        ) {
          this.subTextAddDynamic = "Total Recebido com Acréscimo: ";
        } else {
          this.subTextAddDynamic = "Total Recebido: ";
        }
      }
    },

    filterData(valores) {
      this.carregarLoad(), (this.isLoading = true);
      let nova_consulta = false;

      this.selectedType =
        valores.selectedType === "Jazigo" ? "Cemitérios" : valores.selectedType;
      this.selectedOpcao = valores.selectedOpcao;
      this.selectedCompany = valores.selectedCompany.join(",");
      this.selectMode = valores.selectMode;

      this.selectMode = "Vencimento";

      this.handleFilterChange(
        valores.selectMode,
        valores.selectedStartDate,
        valores.selectedEndDate,
        valores.selectedStartDate2,
        valores.selectedEndDate2
      );
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedStartDate2 = valores.selectedStartDate2;
      this.selectedEndDate2 = valores.selectedEndDate2;
      this.selectedStartDate3 = valores.selectedStartDate3;
      this.selectedEndDate3 = valores.selectedEndDate3;
      this.produto = valores.selectedProduto;
      //this.gf01();
      this.dashboard();
    },

    filtrarTiposFunerarios(tipoFunerario) {
      const tiposPermitidos = "Todos";
      if (this.tipoFunerario === "Jazigo") {
        tiposPermitidos = [
          "CONCESSÃO DE COLUMBÁRIO",
          "CONCESSÃO DE JAZIGOS",
          "CONCESSÃO DE OSSÁRIO",
          "VENDA DE COLUMBÁRIO",
          "VENDA DE JAZIGOS - IMEDIATO",
          "VENDA DE JAZIGOS - PREVENTIVO",
          "VENDA DE JAZIGOS - TRANSITÓRIO",
        ];
      }
      if (this.tipoFunerario === "Plano") {
        tiposPermitidos = [
          "COMPLETO",
          "FAMILIA",
          "INTEGRAL",
          "P23",
          "TOTAL",
          "PF - AMPARO",
          "PROTEÇÃO",
          "PV - AMIGO",
          "PV - BRONZE",
          "PV - CREMAÇÃO COM CERIMÔNIA",
          "PV - DIAMANTE",
          "PV - EMPRESARIAL",
          "PV - EMPRESARIAL - EMPRESA",
          "PV - ESPECIAL",
          "PV - ESMERALDA",
          "PV - ESSENCIAL",
          "PV - IDEAL",
          "PV - MAIOR",
          "PV - MAIS",
          "PV - MASTER GOLD",
          "PV - MELHOR",
          "PV - PLANO PJ",
          "PV - PLUS",
          "PV - POLICIA MILITAR",
          "PV - PRATA",
          "PV - PREVIDA",
          "PV - PREVIPARQ DO AGRESTE",
          "PV - RUBI",
          "PV - SÃO MATHEUS",
        ];
      }

      if (this.tipoFunerario === "Cremação") {
        tiposPermitidos = [
          "CREMAÇÃO",
          "CREMAÇÃO COM CERIMÔNIA",
          "CREMAÇÃO SEM CERIMÔNIA",
          "URNAS CINERARIAS",
        ];
      }

      if (
        this.tipoFunerario === "Todos" ||
        this.tipoFunerario === "Funerária" ||
        this.tipoFunerario === "Serviços Administrativos e Cemiteriais" ||
        this.tipoFunerario === "Serviços Cemiteriais"
      ) {
        tiposPermitidos = ["Todos"];
      }

      if (tiposPermitidos.includes(tipoFunerario)) {
        return true; // Mantém apenas os tipos permitidos
      } else {
        return false; // Remove os tipos não permitidos
      }
    },

    exportToPDF() {
      const doc = new jsPDF("landscape", "pt", "a4"); // Define a orientação da página como paisagem e tamanho A4
      const usuario = JSON.parse(sessionStorage.getItem("user")).nome;

      const titleY = 30; // Posição inicial para o título
      const periodY = titleY + 18; // Posição para o período, 20 unidades abaixo do título
      const maxLinesPerPage = 18; // Limite de linhas por página

      // Cabeçalhos da tabela
      const headers = this.ranking_header.map((header) => header.text);

      // Dados da tabela
      const filteredData = this.lista_comissao
        .filter((item) => parseFloat(item.comissao || 0) > 0) // Filtra itens onde a comissão é maior que 0
        .map((item) =>
          this.ranking_header.map((header) => {
            let value = item[header.value];
            if (header.value === "comissao") {
              return parseFloat(value || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
            }
            return value !== null && value !== undefined ? value : "";
          })
        );

      let startY = titleY + 40; // Posição Y inicial para a tabela
      let pageCount = 0;

      const addTableToPDF = (data, isFirstPage) => {
        doc.autoTable({
          startY: startY,
          head: [headers],
          body: data,
          theme: "grid",
          headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
          columnStyles: { 0: { cellWidth: "auto" } },
          margin: { bottom: 20 },
          didDrawPage: (data) => {
            if (isFirstPage) {
              // Adiciona o título e o período na parte superior da página apenas na primeira página
              doc.setFontSize(14);
              doc.setFont("helvetica", "bold");
              doc.text("Comissão de Entregas", 20, titleY); // Adiciona o título
              doc.setFontSize(12);
              doc.setFont("helvetica", "normal");
              doc.text(
                "Período: " +
                  this.selectedStartDate +
                  " até " +
                  this.selectedEndDate,
                20,
                periodY
              ); // Adiciona o período
            }
          },
        });
      };

      // Processa os dados em blocos de até 20 linhas por página
      for (let i = 0; i < filteredData.length; i += maxLinesPerPage) {
        const pageData = filteredData.slice(i, i + maxLinesPerPage);
        const isFirstPage = i === 0; // Verifica se é a primeira página

        addTableToPDF(pageData, isFirstPage);

        startY = doc.autoTable.previous.finalY + 20; // Ajusta a posição Y para o rodapé

        // Se não for a última página e houver mais dados, adicione uma nova página
        if (i + maxLinesPerPage < filteredData.length) {
          doc.addPage();
          startY = 30; // Reinicia a posição Y para a nova página
        }
      }

      // Adicionar rótulo e valor do total pago na última página
      const totalPagoY = startY + 20;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Total Pago:", 20, totalPagoY); // Adiciona o rótulo

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(
        parseFloat(this.total_pago_comissao || 0).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
        100, // Posição x do valor
        totalPagoY // Posição y do valor
      );

      // Adicionar data e hora no rodapé da última página
      const now = new Date();
      const formattedDate = now.toLocaleDateString("pt-BR");
      const formattedTime = now.toLocaleTimeString("pt-BR");
      const dateTimeString = `Data e Hora de Criação: ${formattedDate} ${formattedTime}`;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      // Data e Hora
      doc.text(dateTimeString, 20, doc.internal.pageSize.height - 30); // Ajusta a posição Y para a data e hora

      // Nome do Usuário
      doc.text("Usuário: " + usuario, 20, doc.internal.pageSize.height - 15); // Ajusta a posição Y para o nome do usuário

      // Salvar o PDF
      doc.save(this.selectedStartDate + "_lista_comissao_entregas.pdf");
    },
    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    startAnimation(targetValue) {
      this.animationInterval = setInterval(() => {
        if (this.animatedValue < targetValue) {
          this.animatedValue += 1; // Atualiza o valor animado
        } else {
          clearInterval(this.animationInterval); // Interrompe a animação quando atingir o valor desejado
        }
      }, 10); // Intervalo em milissegundos entre cada atualização
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateBRAPI(date) {
      if (!date) return "";
      const parsedDate = new Date(this.formatDateBR(date));
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      return `${year}-${month}-${day}`;
    },

    carregarLoad() {
      this.bool_03 = true;
      this.bool_03 = true;
    },

    async dashboard() {
      this.isLoading = true;

      this.selectMode = "Vencimento";
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      const formattedStartDate2 = converteDataParaFormatoISO(
        this.selectedStartDate2
      );
      const formattedEndDate2 = converteDataParaFormatoISO(
        this.selectedEndDate2
      );

      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 365) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 365;
        return;
      }

      Comissao.lista_comissao_alelo_total(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.lista_comissao = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    async exportFeriasToPDF() {
      this.showProgress = true;

      try {
        const formattedStartDate = converteDataParaFormatoISO(
          this.selectedStartDate
        );

        // Buscar dados de férias da API
        const response = await Comissao.lista_ferias(
          formattedStartDate,
          this.selectedCompany
        );

        if (response.status !== 200 || !response.data || response.data.length === 0) {
          alert("Nenhum dado de férias encontrado para o período selecionado.");
          this.showProgress = false;
          return;
        }

        const feriasData = response.data;

        // Criar PDF em paisagem (landscape)
        const doc = new jsPDF("landscape", "pt", "a4");
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        // Obter usuário logado do sessionStorage (mesmo padrão do Comissao.vue)
        const usuario = JSON.parse(sessionStorage.getItem("user"))?.nome || "Usuário";

        // Data e hora atual
        const now = new Date();
        const formattedDate = now.toLocaleDateString("pt-BR");
        const formattedTime = now.toLocaleTimeString("pt-BR");
        const dateTimeString = `Data e Hora de Criação: ${formattedDate} ${formattedTime}`;

        // Determinar logo baseado na empresa selecionada (mesmo padrão do Comissao.vue)
        const logoPath = this.determinarLogo(this.selectedCompany);
        const logoY = 15;
        const logoWidth = 150;
        const logoHeight = 80;

        // Posicionamento (mesmo padrão do Comissao.vue)
        const titleY = 35;
        const periodY = titleY + 20;

        if (logoPath) {
          try {
            doc.addImage(logoPath, "PNG", 20, logoY, logoWidth, logoHeight);
          } catch (error) {
            console.error("Erro ao adicionar logo:", error);
          }
        }

        // Título
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Relatório de Férias - Alelo", pageWidth / 2, titleY, {
          align: "center",
        });

        // Período completo (início até fim)
        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(
          "Período: " + this.selectedStartDate + " até " + this.selectedEndDate,
          pageWidth / 2,
          periodY,
          { align: "center" }
        );

        // Preparar dados para a tabela
        const tableHeaders = [
          "Colaborador",
          "CPF",
          "Valor",
        ];

        const tableData = feriasData.map((item) => [
          item.nome || "",
          item.cpf || "",
          parseFloat(item.comisao || 0).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
        ]);

        // Adicionar tabela
        const startY = periodY + 50;
        doc.autoTable({
          startY: startY,
          head: [tableHeaders],
          body: tableData,
          theme: "grid",
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
          columnStyles: {
            0: { cellWidth: "auto" },
            1: { cellWidth: 100 },
            2: { cellWidth: 80, halign: "right" },
          },
          margin: { bottom: 60 },
          didDrawPage: (data) => {
            // Adicionar logo no topo de cada página
            if (logoPath) {
              try {
                doc.addImage(logoPath, "PNG", 20, logoY, logoWidth, logoHeight);
              } catch (error) {
                console.error("Erro ao adicionar logo:", error);
              }
            }

            // Adicionar título e período em cada página
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text(
              "Relatório de Férias - Alelo",
              pageWidth / 2,
              titleY,
              { align: "center" }
            );

            doc.setFontSize(12);
            doc.setFont("helvetica", "normal");
            doc.text(
              "Período: " + this.selectedStartDate + " até " + this.selectedEndDate,
              pageWidth / 2,
              periodY,
              { align: "center" }
            );

            // Adicionar rodapé em cada página
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text(dateTimeString, 20, pageHeight - 30);
            doc.text("Usuário: " + usuario, 20, pageHeight - 15);
          },
        });

        // Calcular total
        const totalValor = feriasData.reduce(
          (sum, item) => sum + parseFloat(item.comisao || 0),
          0
        );

        // Adicionar total
        const totalY = doc.autoTable.previous.finalY + 20;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("Total:", 20, totalY);
        doc.setFont("helvetica", "normal");
        doc.text(
          totalValor.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          100,
          totalY
        );

        // Salvar PDF
        const fileName = `ferias_alelo_${formattedStartDate}.pdf`;
        doc.save(fileName);
      } catch (error) {
        console.error("Erro ao gerar PDF de férias:", error);
        alert("Erro ao gerar PDF. Tente novamente.");
      } finally {
        this.showProgress = false;
      }
    },

    download_alelo_xls() {
      this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 90) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 90;
        return;
      }

      Comissao.lista_comissao_alelo_tudo_xls(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            // Defina o nome do arquivo zip, se a resposta for um ZIP
            const fileName = `comissao_geral_${Date.now()}.zip`;

            // Cria um URL temporário para o arquivo binário
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );

            // Cria o link de download
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);

            // Adiciona o link à página e simula o clique para baixar
            document.body.appendChild(fileLink);
            fileLink.click();

            // Remove o link da página após o download
            document.body.removeChild(fileLink);
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },

    determinarLogo(empresa) {
      empresa = empresa.replace(",", "");
      try {
        switch (empresa) {
          case "PREVIDA":
            return require("@/assets/logo_previda.png");
          case "PARQUE DAS FLORES":
            return require("@/assets/parque_logo.png");
          case "PARQUE DO AGRESTE":
            return require("@/assets/am_logo.png");
          case "MEMORIAL PARQUE MACEIÓ":
            return require("@/assets/memorial_logo.png");
          case "CEMITERIO PREVIDA":
            return require("@/assets/versan_logo.png");
          default:
            return require("@/assets/logo_grupo.png");
        }
      } catch (error) {
        console.error("Erro ao carregar logo:", error);
        return null;
      }
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getStatus(status) {
      // Convert status to uppercase to make the comparison case insensitive
      const normalizedStatus = status.toUpperCase();

      switch (normalizedStatus) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularComissao: function (empresa, resultado, comissao, original, pago) {
      if (empresa === "PREVIDA") {
        if (resultado < 0) {
          // Se o resultado for negativo, retorna a diferença entre pago e original
          return pago - original;
        } else {
          // Se o resultado não for negativo, retorna a comissão
          return comissao;
        }
      } else {
        // Se a empresa for diferente de "Previda", retorna a comissão
        return comissao;
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },
  },
};

function formatMoeda(value) {
  // Use o método toLocaleString com a opção style: 'currency' para formatar como moeda

  if (value === undefined || value === null) {
    return "R$ 0,00"; // Ou você pode retornar 0 como número, se preferir.
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  //return 0
  //return value
}

function converteDataParaFormatoISO(dataNoFormatoBR) {
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}

function somarTodasQtds(dadosPorUsuario) {
  return Object.values(dadosPorUsuario).reduce((total, item) => {
    return total + item.qtd;
  }, 0);
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(
    71 130 180
  ); /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
